import css from 'styled-jsx/css';

const styles = css.global`/* html {
    scroll-behavior: smooth;
} */

body {
    -webkit-font-smoothing: antialiased;
}

#hero-santander-financiamentos {
    overflow: hidden;
}


#hero-santander-financiamentos .bg-hero img {
    width: 100%;
    object-fit: cover;
    height: calc(100vh - 58px);
    position: absolute;
    max-height: 520px;
    min-height: 408px;
    /* object-position: 72%; */
    object-position: top;

}

#hero-santander-financiamentos .fade-hero-santander {
    width: 100%;
    height: calc(100vh - 58px);
    position: absolute;
    max-height: 520px;
    min-height: 408px;
    background-color: black;
    opacity: .4;
}

#hero-santander-financiamentos .ctn-home-24 {
    position: relative;
}

#hero-santander-financiamentos .hero-contain {
    height: calc(100vh - 58px);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 40px;
    padding-bottom: 34px;
    max-height: 520px;
    min-height: 408px;
}

#hero-santander-financiamentos .hero-title {
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    color: #FFFFFF;
    /* width: 280px; */
}

#hero-santander-financiamentos .hero-sub-title {
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #FFFFFF;
    /* width: 280px; */
}

#hero-santander-financiamentos .hero-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
}

#hero-santander-financiamentos .hero-buttons a {
    width: 100%;
    max-width: 272px;
    height: 48px;
}

#hero-santander-financiamentos .img-hero-desk {
    display: none;
}

@media (min-width: 600px) {
    #hero-santander-financiamentos .bg-hero picture {
        position: absolute;
        height: 100%;
        width: 100%;
    }

    #hero-santander-financiamentos .fade-hero-santander,
    #hero-santander-financiamentos .bg-hero img {
        /* max-height: 640px; */
        height: calc(100vh - 140px);
        min-height: 420px;
    }

    #hero-santander-financiamentos .hero-contain {
        /* max-height: 640px; */
        align-items: flex-start;
        padding-top: 48px;
        padding-bottom: 64px;
        height: calc(100vh - 140px);
        min-height: 420px;
    }

    #hero-santander-financiamentos .hero-title {
        font-size: 64px;
        line-height: 120%;
        width: 100%;
        max-width: 832px;
        z-index: 2;
        position: relative;
    }

    #hero-santander-financiamentos .hero-sub-title {
        font-size: 32px;
        line-height: 120%;
        width: 100%;
        max-width: 716px;
        margin-top: 16px;
        z-index: 2;
        position: relative;
    }

    #hero-santander-financiamentos .hero-buttons {
        flex-direction: row;
        align-items: center;
        gap: 16px;
        z-index: 2;
    }

    #hero-santander-financiamentos .hero-buttons a {
        width: 272px;
        max-width: 272px;
    }


}

/* @media (min-width: 1250px ) and (min-height: 300px) {
    #hero-santander-financiamentos .img-hero-desk {
        display: block;
        position: absolute;
        bottom: 0;
        right: -30px;
        width: 420px;
    }
}


@media (min-width: 1250px ) and (min-height: 700px) {
    #hero-santander-financiamentos .hero-contain {
        padding-top: 130px;
        padding-bottom: 130px;
    }
    #hero-santander-financiamentos .img-hero-desk {
        display: block;
        position: absolute;
        bottom: 0;
        right: -100px;
        width: auto;
    }
} */`;

export default styles;